import jQuery from 'jquery'
import actions from 'shared/helpers/vuex/actions'
import moment from 'shared/helpers/moment'

export default {
    ...actions,
    onSaveQuotation({ commit }, payload) {
        let quotation = {            
            guid: payload.data.guid,
            token: payload.config.token,            
            validity: {
                quotation_date: (moment(payload.data.quotation_date, 'DD/MM/YYYY').isValid() ? moment(payload.data.quotation_date, 'DD/MM/YYYY', "pt", true ) : ''),
                validity_start: (moment(payload.data.validity_start, 'DD/MM/YYYY').isValid() ? moment(payload.data.validity_start, 'DD/MM/YYYY', "pt", true ) : ''),
                validity_end: (moment(payload.data.validity_end, 'DD/MM/YYYY').isValid() ? moment(payload.data.validity_end, 'DD/MM/YYYY', "pt", true ) : ''),
            },
            renewal: {
                insurer: payload.data.renewal.insurer,
                bonus_last: payload.data.renewal.bonus_last,
                bonus_current: payload.data.renewal.bonus_current,
                claim_amount: payload.data.renewal.claim_amount,
                prior_policy_end: (moment(payload.data.renewal.prior_policy_end, 'DD/MM/YYYY').isValid() ? moment(payload.data.renewal.prior_policy_end, 'DD/MM/YYYY', "pt", true ) : ''),
                prior_policy: payload.data.renewal.prior_policy,
                prior_ic: payload.data.renewal.prior_ic
            },
            customer: {
                document:        payload.data.customer.document,
                name:            payload.data.customer.name,
                email:           payload.data.customer.email,
                phone:           payload.data.customer.phone,
                celphone:        payload.data.customer.celphone
            },
            residencia: {
                id:                payload.data.residence.id,
                walk:              payload.data.residence.walk,
                type_construction: payload.data.residence.type_construction,
                location:          payload.data.residence.location,
                street:            payload.data.residence.street,
                number:            payload.data.residence.number,
                complement:        payload.data.residence.complement,
                zip_code:          payload.data.residence.zip_code,
                neighborhood:      payload.data.residence.neighborhood,
                city:              payload.data.residence.city,
                state:             payload.data.residence.state,
                extinguisher:      payload.data.residence.extinguisher,
                hydrant:           payload.data.residence.hydrant,
                srinkler:          payload.data.residence.srinkler,
                smoke_detector:    payload.data.residence.smoke_detector,
                fire_brigade:      payload.data.residence.fire_brigade,
                local_alarm:       payload.data.residence.local_alarm,
                closed_circuit:    payload.data.residence.closed_circuit,
                security_24h:      payload.data.residence.security_24h,
                grid_tetra_lock:   payload.data.residence.grid_tetra_lock,
                infrared_sensor:   payload.data.residence.infrared_sensor,
                monitored_alarm:   payload.data.residence.monitored_alarm,
                activity:          payload.data.residence.activity,
                activity_cnae:     payload.data.residence.activity_cnae
            },
            questionnaire: {
                storage_material:        payload.data.questionnaire.storage_material,
                wasted_currency:         payload.data.questionnaire.wasted_currency,
                historical_heritage:     payload.data.questionnaire.historical_heritage,
                metal_structure:         payload.data.questionnaire.metal_structure,
                boxes_electronics:       payload.data.questionnaire.boxes_electronics,
                isopainel:               payload.data.questionnaire.isopainel,
                construction_renovation: payload.data.questionnaire.construction_renovation

            },
            coverage: {
                assistance:              payload.data.coverage.assistance,
                new_property:            payload.data.coverage.new_property,
                building_value:          payload.data.coverage.building_value,
                content_value:           payload.data.coverage.content_value,
                basic:                   payload.data.coverage.basic,
                electrical_damages:      payload.data.coverage.electrical_damages,
                glasses:                 payload.data.coverage.glasses,
                theft_goods:             payload.data.coverage.theft_goods,
                theft_values:            payload.data.coverage.theft_values,
                equipments:              payload.data.coverage.equipments,
                wind:                    payload.data.coverage.wind,
                vehicle_impact:          payload.data.coverage.vehicle_impact,
                landslip:                payload.data.coverage.landslip,
                adverts:                 payload.data.coverage.adverts,
                rent_payment:            payload.data.coverage.rent_payment,
                turmoil:                 payload.data.coverage.turmoil,
                recomposition_documents: payload.data.coverage.recomposition_documents,
                liability_operations:    payload.data.coverage.liability_operations,
                liability_employer:      payload.data.coverage.liability_employer,
                moral_damages:           payload.data.coverage.moral_damages,
                fixed_expenses:          payload.data.coverage.fixed_expenses,
                business_interruption:   payload.data.coverage.business_interruption,
                leaks:                   payload.data.coverage.leaks,
                shower:                  payload.data.coverage.shower,
                loyalty:                 payload.data.coverage.loyalty
            }
            
        }

        commit('lastQuotationSaved', { ...quotation })

        MulticalculoEmpresarial.onSave({ ...quotation })
        MulticalculoEmpresarial.onSaveClient({ ...quotation })
    },
    onSaveInsurerQuotation(context, payload) {
        const insurerQuotation = {
            type:            'enterprise',
            preco_id:        payload.preco_id,
            cotacao_id:      payload.cotacao_id,
            seguradora:      payload.seguradora,
            codigo:          payload.codigo,
            status:          payload.status,
            mensagem:        '',
            // mensagem:        payload.mensagem.replace(/\n/, '<br>') + '<br>' + payload.mensagem_ajuste.replace(/\n/, '<br>'),
            franquia:        payload.franquia,
            valor:           payload.valor,
            valor_parcelado: ''
        }
        // valor_parcelado: JSON.parse(payload.valor_parcelado)

        MulticalculoEmpresarial.onSaveInsurerQuotation({ ...insurerQuotation })
    }
}


// WEBPACK FOOTER //
// ./src/enterprise/vuex/actions.js